import { render, staticRenderFns } from "./EventsHandleEventsDocumentationV2.vue?vue&type=template&id=3d3c56b2&scoped=true&"
import script from "./EventsHandleEventsDocumentationV2.vue?vue&type=script&lang=js&"
export * from "./EventsHandleEventsDocumentationV2.vue?vue&type=script&lang=js&"
import style0 from "./EventsHandleEventsDocumentationV2.vue?vue&type=style&index=0&id=3d3c56b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c56b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardText,VCardTitle,VSimpleTable})
